<template>
  <v-container>
    <v-row color="primary">
      <v-col>
        <v-card color="primary">
          <v-row>
            <v-col>
              <v-btn :to="'/cidade/' + municipioId" color="primary" outlined>
                <v-icon color="white" large> mdi-arrow-left-bold </v-icon>
              </v-btn>
            </v-col>
            <v-col align="center" justify="center">
              <v-img justify="center" :src="'/assets/img/' + logo" width="20%">
              </v-img>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-card-text>
                <h2 class="text-center white--text">
                  CLIQUE SOBRE UM TEMA PARA RESPONDER AS PERGUNTAS
                </h2>
              </v-card-text>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              align="center"
              v-for="tema in temas"
              v-bind:key="tema.temaId"
            >
              <a @click="answerTheme(tema)">
                <v-progress-circular
                  size="150"
                  :value="
                    (tema.perguntasRespondidas / tema.perguntasTema) * 100
                  "
                  width="15"
                  color="warning"
                  background-color="warning"
                  v-if="!isSala"
                >
                  <img
                    :src="'/assets/img/temas/' + tema.tema.imagem"
                    width="130px"
                    class="tema-image"
                  />
                </v-progress-circular>
                <v-progress-circular
                  size="150"
                  :value="
                    (tema.perguntasRespondidas / tema.perguntasTema) * 100
                  "
                  width="15"
                  color="azulclarosc"
                  background-color="warning"
                  v-if="isSala"
                >
                  <img
                    :src="'/assets/img/temas/' + tema.tema.imagem"
                    width="130px"
                    class="tema-image"
                  />
                </v-progress-circular>
                <!--
                <h4
                  class="text-center white--text"
                >
                  {{ tema.tema.nome }}
                </h4>
              --> </a
              ><br />
              <v-btn
                v-if="
                  estado === 'SC' ||
                  estado === 'BA' ||
                  estado === 'SP' ||
                  estado === 'MA'
                "
                color="error"
                class="ml-3"
                @click="downloadQuestions(tema.temaId)"
              >
                DOWNLOAD PERGUNTAS
              </v-btn>
            </v-col>
          </v-row>

          <v-row v-if="false">
            <v-col class="text-center">
              <v-btn
                color="error"
                class="ml-3"
                @click="finishDiagnostic()"
                v-if="temasRespondidos"
              >
                FINALIZAR DIAGNÓSTICO
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { attendanceThemeAPI } from "./AttendanceThemeAPI";
import { diagnosticAPI } from "./DiagnosticAPI";
import { mapActions, mapGetters } from "vuex";
import { cityQuestionAPI } from "@/modules/city";

export default {
  data() {
    return {
      temas: [],
      municipioId: parseInt(this.$route.params.id),
      temasRespondidos: false,
      temasFinalizados: 0,
      logo: this.$store.state.logo,
      estado: this.$store.state.uf,
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    loadThemes() {
      this.setLoading(true);
      attendanceThemeAPI
        .getByCity(this.municipioId)
        .then((resp) => {
          this.temas = resp.data;

          this.temas = this.temas.filter((tema) =>
            tema.municipio.temas.some(
              (munTema) => munTema.temaId === tema.temaId
            )
          );

          if (!this.user.grupo.verTodosEixos) {
            this.temas = this.temas.filter((item) =>
              this.user.permissoes.some(
                (per) =>
                  per.eixoId === item.tema.eixoId &&
                  per.municipioId === this.municipioId
              )
            );
          }

          for (let i = 0; i < resp.data.length; i++) {
            if (
              resp.data[i].perguntasTema === resp.data[i].perguntasRespondidas
            ) {
              this.temasFinalizados = this.temasFinalizados + 1;
            }
          }

          if (this.temasFinalizados === resp.data.length) {
            this.temasRespondidos = true;
          }
          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("Erro ao listas diagnosticos: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter temas");
        });
    },
    answerTheme(tema) {
      for (let i = 0; i < tema.municipio.temas.length; i++) {
        if (
          tema.municipio.temas[i].temaId === tema.temaId &&
          tema.municipio.temas[i].diagnosticoFinalizado === false
        ) {
          this.$router.push(
            "/diagnostico/" + this.municipioId + "/tema/" + tema.temaId
          );
        }
      }
    },
    finishDiagnostic() {
      this.setLoading(true);

      diagnosticAPI
        .finish(this.municipioId)
        .then((resp) => {
          this.$router.push("/cidade/" + this.municipioId);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao finalizar diagnóstico");
        });
    },
    downloadQuestions(temaId) {
      this.setLoading(true);

      cityQuestionAPI
        .getPDFPerguntasTema(temaId)
        .then((resp) => {
          let blob = new Blob([resp.data], { type: "application/pdf" });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "Perguntas.pdf";
          link.click();
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter PDF de perguntas");
        });
    },
  },
  computed: {
    ...mapGetters(["loading", "isSala", "user"]),
  },
  mounted() {
    document.getElementsByClassName("v-content__wrap")[0].style.background =
      'url("/assets/img/bg-diagnostico.jpg") repeat';
    this.loadThemes();
  },
};
</script>

<style lang="scss">
@import "./style.scss";
</style>
